import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import VoteWithoutAuth from "../Components/VoteWithoutAuth/VoteWithoutAuth";
import LoginForm from "../../LoginForm/LoginForm";

export function VoteWithoutAuthModal({
  showLogin,
  setShowLogin,
  onVoteClick,
  selectedPhoto,
  onVoteCallback,
}) {
  const { t } = useTranslation(["widgets"]);

  return (
    <Modal
      isOpen={showLogin}
      onRequestClose={() => setShowLogin(false)}
      style={{
        overlay: {
          zIndex: "1000",
          backgroundColor: "rgba(0,0,0,0.6)",
        },
        content: {
          width: "100%",
          maxWidth: "670px",
          margin: "0 auto",
          bottom: "unset",
          borderRadius: 0,
          padding: 0,
          overflowX: "hidden",
          backgroundColor: "#ffffff",
        },
      }}
    >
      <div className="modal__login">
        <div className="modal__login__text">{t("widgets:popup.altLogin")}</div>
        <LoginForm
          onLoginCallback={() => {
            setShowLogin(false);
          }}
        />
        <VoteWithoutAuth
          photo={selectedPhoto}
          onVote={onVoteClick}
          onVoteCallback={onVoteCallback}
        />
      </div>
    </Modal>
  );
}
